// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"fdd66304","453":"d561b444"}[chunkId] + ".chunk.js";
};